var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{attrs:{"href":_vm.ContactEmailAddress}},[_c('div',{staticClass:"button"},[_c('div',{staticClass:"button-image",style:(_vm.imageCss),attrs:{"src":_vm.contactImage}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }